import React, {Component} from 'react'
import {style, media, merge} from 'glamor'
import * as colors from '../colors'
import Match from 'react-router/Match'
import HomeMobile from './HomeMobile'
import Category from './Category'

export default class Home extends Component {

  shouldComponentUpdate(){
    return false
  }

  render(){
    return (
      <div
        {...merge(
          style({
          color: colors.nearBlack,
          background: colors.white,
        })
      )}
      >

        <Match
          exactly
          pattern={
            `(${this.props.pages.reduce((pattern, page)=>{
              return pattern + '|' + page.url
            }, '')})`
          }
          render={(matchProps) => (
            <HomeMobile
              {...matchProps}
              {...this.props}
            />
          )}
        />


          <Match
            pattern="/:type/:category"
            render={(matchProps) => (
              <Category
                {...matchProps}
                {...this.props}
              />
            )}
          />

      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AppMobile.js
 **/